import _ from 'lodash'
import React, { Component } from 'react'
import styled from 'styled-components'
import qs from 'qs'
import { connect } from 'react-redux'
import { updateCalculator, fetchProvinces } from '../../../actions/calculator'
import Banner from '../../Calculator/Banner'
import TransportoIcon from '../../UI/Icons/Transporto'
import Button from '../../UI/Button'
import { Wrapper, Caret } from './Step0'
import LogisticsForm from '../../Forms/Logistics'
import { device, priceFormatted, getNetPrice, getTax } from '../../../utils/helpers'
import { formValueSelector } from 'redux-form'

const Title = styled.div`
  display: flex;
  padding: 15px 0;
  align-items: center;
  justify-content: center;
  background-color: #999999;
  margin-top: 24px;
  font-size: 28px;
  color: #fff;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;

  @media ${device.tablet} {
    font-size: 2.5vw;
    padding: 1.3020833333333335vw 0;
    margin-top: 1.25vw;
    margin-bottom: 1.25vw;
  }
`

const TariffWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e2e2e2;
  flex-direction: column;
  margin-top: 24px;
  height: 190px;
  text-align: center;

  @media ${device.tablet} {
    ${''/* height: 287px; */}
    height: 14.947916666666668vw;
    margin-top: 1.25vw;
  }

  ${'' /* @media ${device.tablet} {
    height: 76%;
  }

  @media ${device.tabletM} {
    height: 71%;
  } */}
`

const Content = styled.div`
  @media ${device.tablet} {
    display: flex;
    justify-content: space-between;
  }
`

const TariffHeading = styled.h2`
  font-family: 'BarlowExtraBold';
  padding-bottom: 22px;
  margin-top: -45px;
  font-size: 24px;

  @media ${device.tablet} {
    font-size: 1.6666666666666667vw;
  }
`

const Price = styled.h1`
  font-family: 'BarlowExtraBold';
  font-size: 32px;

  @media ${device.tablet} {
    font-size: 2.5vw;
  }
`

const FormWrapper = styled.div`
  @media ${device.tablet} {
    width: 63%;
  }

  @media (min-width: 1770px) {
    width: 58%;
  }
`

const Preview = styled.div`
  @media ${device.tablet} {
    width: 35%;
  }

  @media (min-width: 1770px) {
    width: 40%;
  }
`

const Transporto = styled(TransportoIcon)`
  width: 175px;

  @media ${device.tablet} {
    width: 9.114583333333334vw;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
`

class Step5 extends Component {
  state = {
    provinceName: '',
    error: ''
  }

  componentDidMount () {
    // Set the current step to active and visited
    this.props.updateCalculator(5, {
      active: true,
      visited: true
    })
    this.props.fetchProvinces()
  }

  handleNextClick () {
    const { logisticsAmount, address, street, zipcode, city, province, provinces } = this.props
    if (!address || !street || !zipcode || !city || !province) {
      this.setState({ error: 'Si prega di compilare tutti i campi' })
    } else {
      const { sport } = this.props.match.params
      const variant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
      const path = `/noleggia/${sport}/6?variant=${variant}`
      const provinceName = _.find(provinces, { id: province }).name
      const data = {
        price: logisticsAmount,
        net: getNetPrice(logisticsAmount),
        tax: getTax(logisticsAmount),
        selectedComponent: `${address} ${street}, ${city}, ${provinceName} - ${zipcode}`,
        address: {
          address,
          street,
          zipcode,
          city,
          province
        }
      }
      console.log(data)
      this.props.updateCalculator(5, data)
      this.props.updateCalculator(6, { path })
      this.props.history.push(path)
    }
  }

  handleUpdateProvince (province) {
    this.setState({ provinceName: province })
  }

  render () {
    const { logisticsAmount, provinces } = this.props
    const { sport } = this.props.match.params // Sport token from URL
    const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    return (
      <Wrapper>
        <Banner
          icon={<Transporto fill='#fca317' />}
          title='LOGISTICA'
          subtitle='INSERISCI I DATI PER; TRASPORTO E MONTAGGIO'
        />
        <Content>
          <FormWrapper>
            <Title>
              DOV’È IL TUO EVENTO?
            </Title>
            <LogisticsForm
              provinces={provinces}
              updateProvince={this.handleUpdateProvince.bind(this)}
            />
          </FormWrapper>
          <Preview>
            <Title>
              TRASPORTO
            </Title>
            <TariffWrapper style={{ position: 'relative' }}>
              <TariffHeading>TARIFFA<br />LOGISTICA</TariffHeading>
              <Price>+ {logisticsAmount ? priceFormatted(logisticsAmount) : '0 €'}</Price>
              <div style={{
                lineHeight: '1.15em',
                position: 'absolute',
                padding: '0 20px 0 20px',
                bottom: 20,
                fontSize: '0.8em',
              }}>
                Per i trasporti sotto la provincia di Roma, il prezzo è indicativo. Un preventivo preciso potrà essere redatto dopo aver preso contatto con il cliente.
              </div>
            </TariffWrapper>
          </Preview>
        </Content>
        <ButtonWrapper>
          <Button to={`/noleggia/${sport}/4?variant=${currentVariant}`} size='small'><Caret transform='rotate(180)' fill='#fff' /> &nbsp;&nbsp; STEP PRECEDENTE</Button>
          <Button onClick={this.handleNextClick.bind(this)} size='small'>STEP SUCCESSIVO &nbsp;&nbsp; <Caret fill='#fff' /></Button>
        </ButtonWrapper>
        <p style={{ color: 'red', textAlign: 'right' }}>{this.state.error}</p>
      </Wrapper>
    )
  }
}

// Access the logistics form values
const selector = formValueSelector('LogisticsForm')

function mapStateToProps (state) {
  return {
    logisticsAmount: state.calculator.logisticsAmount,
    provinces: state.calculator.provinces,
    address: selector(state, 'address'),
    street: selector(state, 'street'),
    zipcode: selector(state, 'zipcode'),
    city: selector(state, 'city'),
    province: selector(state, 'province')
  }
}

export default connect(mapStateToProps, { updateCalculator, fetchProvinces })(Step5)



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Step5.js